import { Component, OnInit, Inject } from '@angular/core';

import { DocumentationService } from '../../services/documentation.service';
import { IPageComponent } from '../../interfaces/ipagecomponent';

import { PaginationComponent, PageEvent } from '~Components/pagination/pagination.component';

/**
 * Composant de documentation
 * @extends IPageComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss']
})
export class DocumentationComponent extends IPageComponent implements OnInit {
    listeDocuments: any[];
    total: number = 0;
    indexPage: number = 0;
    taillePage: number = 4;
    recherche: string = '';
    filtrerLangue: boolean = true;

    /**
     * Constructeur
     * @param documentationService
     */
    constructor(@Inject(DocumentationService) private documentationService: DocumentationService)
    {
        super()
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

    /**
     * Obtenir le titre de la recherche 
     */
    public get titreRecherche() {
        return this.recherche ? ('Recherche pour "' + this.recherche + '"') : '';
    }

    /**
     * Ev�nement lors du changement de page
     * @param e
     */
    public changementPageEvent(e: PageEvent) {
        if (this.indexPage == e.indexPage && this.taillePage == e.taillePage) {
            return;
        }

        this.listeDocuments = [];

        this.indexPage = e.indexPage;
        this.taillePage = e.taillePage;

        this.lancerRecherche();
    }

    /**
     * Ev�nement de recherche
     * @param recherche
     */
    public rechercheEvent(event: any) {
        this.recherche = event.Recherche;
        this.filtrerLangue = event.RechercherDansToutesLesLangues ? false : true;
        this.indexPage = 0;
        this.lancerRecherche();
    }

    /**
     * Lancer la recherche
     */
    public lancerRecherche() {
        this.lister();
    }

    /**
     * Lister les documentations
     */
    private lister(): void {
        // Lister
        this.documentationService.paginer(this.recherche, this.filtrerLangue, this.indexPage, this.taillePage).subscribe((retour: any) => {
            if (retour && retour.Result && retour.Result) {
                this.listeDocuments = retour.Result.Liste;
                this.total = retour.Result.Total;
            }
        }, (erreur) => {
            console.error(erreur);
        });
    }
}
